export const Marketreviews = [
    {
      name: "Heather",
      message:
        "Absolutely amazing! From the start - was kind, communicative, and helpful. The team made us all feel truly beautiful—10/10 experience!",
    },
    {
      name: "Kelsey",
      message:
        "Blush artists always do a fantastic job. It's so easy to book and the hair stylists and makeup artists are always so professional and nice! I always recommend Blush to friends.",
    },
    {
      name: "Katja",
      message:
        "Blush was absolutely amazing from start to finish! They are so kind and enthusiastic and their communication made the process so easy.",
    },
    {
      name: "Sarah",
      message:
        "Did an amazing job. Thank you so so much blush. You’re an amazing company and I will definitely be using you again in the future.",
    },
    {
      name: "Keisha",
      message:
        "Blush is AMAZING! I had never experienced getting my makeup done professionally, let alone having someone come and do my makeup—but it was such a cool experience.",
    },
    {
      name: "Angelica",
      message:
        "Blush was SUCH a pleasure to work with! We were scrambling last minute, and they were so willing to help us out! Everything was effortless about the entire process- from booking to the final prom look.",
    },
  ];